// src/components/leads/add-team.jsx

import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import { SUBSCRIPTION_TYPE_OPTIONS } from "./subscription-types";
import { parseDateInputLocal } from "../../utils/calendarDate";

const AddTeamForm = ({ show, handleClose, refreshTeams }) => {
  const [teamName, setTeamName] = useState("");
  const [conference, setConference] = useState("");
  const [division, setDivision] = useState("");
  const [status, setStatus] = useState("Active");
  const [assignedStaff, setAssignedStaff] = useState("");
  const [lastContact, setLastContact] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!teamName.trim()) {
      toast.error("Team Name is required");
      return;
    }
    setSaving(true);
    try {
      await db.collection("Teams").add({
        teamName: teamName.trim(),
        conference: conference.trim(),
        division: division.trim(),
        status,
        assignedStaff: assignedStaff.trim(),
        lastContact: lastContact ? parseDateInputLocal(lastContact) : null,
        createdAt: new Date(),
      });
      toast.success("Team added successfully");
      refreshTeams();
      handleClose();

      // Reset fields
      setTeamName("");
      setConference("");
      setDivision("");
      setStatus("Active");
      setAssignedStaff("");
      setLastContact("");
    } catch (err) {
      console.error("Error adding team:", err);
      toast.error("Could not add team");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Team</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Team Name */}
          <Form.Group className="mb-3" controlId="addTeamName">
            <Form.Label>Team Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter team name"
              value={teamName}
              onChange={(e) => setTeamName(e.target.value)}
            />
          </Form.Group>

          {/* Conference */}
          <Form.Group className="mb-3" controlId="addConference">
            <Form.Label>Conference</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. ACC, SEC"
              value={conference}
              onChange={(e) => setConference(e.target.value)}
            />
          </Form.Group>

          {/* Subscription type (stored as division) */}
          <Form.Group className="mb-3" controlId="addSubscriptionType">
            <Form.Label>Subscription Type</Form.Label>
            <Form.Select
              value={division}
              onChange={(e) => setDivision(e.target.value)}
            >
              <option value="">Select subscription type…</option>
              {SUBSCRIPTION_TYPE_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Status */}
          <Form.Group className="mb-3" controlId="addStatus">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Active">Active (Current Client)</option>
              <option value="Pending">Pending (Prospective Client)</option>
              <option value="Inactive">Inactive (Former Client/Dead End)</option>
            </Form.Select>
          </Form.Group>

          {/* Assigned Staff */}
          <Form.Group className="mb-3" controlId="addAssignedStaff">
            <Form.Label>Assigned Staff</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. Sarah Johnson"
              value={assignedStaff}
              onChange={(e) => setAssignedStaff(e.target.value)}
            />
          </Form.Group>

          {/* Last Contact */}
          <Form.Group className="mb-3" controlId="addLastContact">
            <Form.Label>Last Contact</Form.Label>
            <Form.Control
              type="date"
              value={lastContact}
              onChange={(e) => setLastContact(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Team"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddTeamForm;
